import api from "../../index";

export const AddUpdateEmailTemplateApi = (data) => api.post('add-update-email-template', data);
export const GetEmailTemplateListApi = () => api.post('get-email-template');
export const SendMailApi = (data) => api.post('admin-send-mail', data);
